import Subscriber from 'live/services/subscription'
import Registry from 'live/services/registry'

class TimelineService {

    _url = '/services/plugin-annotations/timeline-query/'
    subscriber = new Subscriber({ url: this._url })

    get url () {
        return this._url
    }

    tooltipComponentRegistry = new Registry()

    setupTimelineRequest (span: string, dashboardId: number, onEvent, lookupValues?: { [key:string]: Array<string> }) {
        this.subscriber.close()

        this.subscriber.delegate((type, e) => onEvent(type, e))

        const params = { span, dashboardId, lookupValues }

        // Due to a limitation of the subscription service, number of requests must match of the number of responses
        // as the TimelineQueryResource generates two queries, we are creating two similar requests. Second one will be ignored.
        this.subscriber.request(params)
        this.subscriber.request(params)

        this.subscriber.flush()
    }

    closeTimelineRequest () {
        this.subscriber.close()
    }

}

const timelineService = new TimelineService()

export default timelineService
